(function () {
    "use strict";

    function loadGoogleMaps() {
        if (window.google && window.google.maps && window.google.maps.importLibrary) {
            return Promise.resolve(window.google.maps);
        }

        return Promise.reject(new Error("Google Maps failed to load."));
    }

    function getMarkerData(root) {
        return Array.prototype.slice.call(root.querySelectorAll("[data-directory-map-marker]"))
            .map(function (element) {
                var latitude = parseFloat(element.dataset.latitude);
                var longitude = parseFloat(element.dataset.longitude);

                if (isNaN(latitude) || isNaN(longitude)) {
                    return null;
                }

                return {
                    address: element.dataset.address || "",
                    avatar: element.dataset.avatar || "",
                    description: element.dataset.description || "",
                    element: element,
                    latitude: latitude,
                    link: element.dataset.link || "",
                    longitude: longitude,
                    shortAddress: element.dataset.shortAddress || "",
                    title: element.dataset.title || ""
                };
            })
            .filter(Boolean);
    }

    function setStatus(root, message) {
        var status = root.querySelector("[data-directory-map-status]");
        if (status) {
            status.textContent = message;
        }
    }

    function createInfoWindowAddressRow(text, className, markerImageUrl, accentColor) {
        var row = document.createElement("div");
        var iconWrapper = document.createElement("span");
        var textElement = document.createElement("span");

        row.className = className;
        iconWrapper.className = "directory-map__info-address-icon-wrapper";
        textElement.className = className + "-text";
        textElement.textContent = text;

        if (accentColor) {
            iconWrapper.style.backgroundColor = accentColor;
        }

        if (markerImageUrl) {
            var icon = document.createElement("img");
            icon.src = markerImageUrl;
            icon.alt = "";
            icon.className = "directory-map__info-address-icon";
            icon.loading = "lazy";
            icon.decoding = "async";
            iconWrapper.appendChild(icon);
        }

        row.appendChild(iconWrapper);
        row.appendChild(textElement);

        return row;
    }

    function createInfoWindowContent(markerData, markerImageUrl, accentColor) {
        var container = document.createElement("div");
        var wrapper = document.createElement("div");
        var addressBlock = document.createElement("div");
        var content = document.createElement("div");
        var heading = document.createElement("span");

        container.className = "directory-map__info-window";
        wrapper.className = "directory-map__info";
        addressBlock.className = "directory-map__info-address-block";
        content.className = "directory-map__info-content";
        heading.className = "directory-map__info-title";

        if (markerData.link) {
            var link = document.createElement("a");
            link.href = markerData.link;
            link.textContent = markerData.title;
            heading.appendChild(link);
        } else {
            heading.textContent = markerData.title;
        }

        content.appendChild(heading);

        if (markerData.description) {
            var description = document.createElement("p");
            description.className = "directory-map__info-description";
            description.textContent = markerData.description;
            content.appendChild(description);
        }

        if (markerData.shortAddress) {
            var shortAddress = createInfoWindowAddressRow(
                markerData.shortAddress,
                "directory-map__info-short-address",
                markerImageUrl,
                accentColor
            );
            addressBlock.appendChild(shortAddress);
        }

        if (markerData.address) {
            var address = document.createElement("div");
            address.className = "directory-map__info-address";
            address.textContent = markerData.address;
            addressBlock.appendChild(address);
        }

        wrapper.appendChild(content);

        if (markerData.avatar) {
            var avatarWrapper = document.createElement("div");
            var avatar = document.createElement("img");
            avatarWrapper.className = "directory-map__info-avatar-wrapper";
            avatar.src = markerData.avatar;
            avatar.alt = "";
            avatar.className = "directory-map__info-avatar";
            avatar.loading = "lazy";
            avatar.decoding = "async";
            avatarWrapper.classList.add("is-loading");
            avatar.addEventListener("load", function () {
                avatarWrapper.classList.remove("is-loading");
            });
            avatar.addEventListener("error", function () {
                avatarWrapper.classList.remove("is-loading");
            });
            if (avatar.complete) {
                avatarWrapper.classList.remove("is-loading");
            }
            avatarWrapper.appendChild(avatar);
            wrapper.appendChild(avatarWrapper);
        }

        container.appendChild(wrapper);

        if (addressBlock.childNodes.length) {
            container.appendChild(addressBlock);
        }

        return container;
    }

    function createMarkerImageContent(markerImageUrl, markerTitle) {
        if (!markerImageUrl) {
            return null;
        }

        var image = document.createElement("img");
        image.src = markerImageUrl;
        image.alt = "";
        image.className = "directory-map__marker-image";
        image.loading = "lazy";
        image.decoding = "async";
        image.setAttribute("aria-label", markerTitle || "");

        return image;
    }

    function getClusterStyles(root) {
        return {
            backgroundColor: root.dataset.clusterBackgroundColor || "#1f6feb",
            fontSize: 14,
            textColor: root.dataset.clusterTextColor || "#ffffff"
        };
    }

    function hexToRgb(hex) {
        var normalizedHex = typeof hex === "string" ? hex.replace("#", "") : "";

        if (normalizedHex.length === 3) {
            normalizedHex = normalizedHex.split("").map(function (character) {
                return character + character;
            }).join("");
        }

        if (normalizedHex.length !== 6) {
            return null;
        }

        return {
            blue: parseInt(normalizedHex.slice(4, 6), 16),
            green: parseInt(normalizedHex.slice(2, 4), 16),
            red: parseInt(normalizedHex.slice(0, 2), 16)
        };
    }

    function createClusterMarkerContent(clusterStyles, count) {
        var backgroundRgb = hexToRgb(clusterStyles.backgroundColor);
        var outerRingColor = backgroundRgb ? "rgba(" + backgroundRgb.red + ", " + backgroundRgb.green + ", " + backgroundRgb.blue + ", 0.22)" : clusterStyles.backgroundColor;
        var middleRingColor = backgroundRgb ? "rgba(" + backgroundRgb.red + ", " + backgroundRgb.green + ", " + backgroundRgb.blue + ", 0.38)" : clusterStyles.backgroundColor;
        var wrapper = document.createElement("div");
        var middleRing = document.createElement("div");
        var innerCircle = document.createElement("div");
        var text = document.createElement("span");

        wrapper.style.alignItems = "center";
        wrapper.style.background = outerRingColor;
        wrapper.style.borderRadius = "50%";
        wrapper.style.display = "flex";
        wrapper.style.height = "34px";
        wrapper.style.justifyContent = "center";
        wrapper.style.width = "34px";

        middleRing.style.alignItems = "center";
        middleRing.style.background = middleRingColor;
        middleRing.style.borderRadius = "50%";
        middleRing.style.display = "flex";
        middleRing.style.height = "30px";
        middleRing.style.justifyContent = "center";
        middleRing.style.width = "30px";

        innerCircle.style.alignItems = "center";
        innerCircle.style.background = clusterStyles.backgroundColor;
        innerCircle.style.borderRadius = "50%";
        innerCircle.style.display = "flex";
        innerCircle.style.height = "26px";
        innerCircle.style.justifyContent = "center";
        innerCircle.style.width = "26px";

        text.style.color = clusterStyles.textColor;
        text.style.fontFamily = "Arial, sans-serif";
        text.style.fontSize = clusterStyles.fontSize + "px";
        text.style.fontWeight = "600";
        text.style.lineHeight = "1";
        text.textContent = String(count);

        innerCircle.appendChild(text);
        middleRing.appendChild(innerCircle);
        wrapper.appendChild(middleRing);

        return wrapper;
    }

    function createClusterRenderer(clusterStyles, AdvancedMarkerElement) {
        return {
            render: function (cluster) {
                return new AdvancedMarkerElement({
                    content: createClusterMarkerContent(clusterStyles, cluster.count),
                    position: cluster.position,
                    title: String(cluster.count),
                    zIndex: 1000 + cluster.count
                });
            }
        };
    }

    function initMap(root) {
        var clusterStyles = getClusterStyles(root);
        var mapId = root.dataset.mapId || "DEMO_MAP_ID";
        var markerAccentColor = root.dataset.clusterBackgroundColor || clusterStyles.backgroundColor;
        var markerImageUrl = root.dataset.markerImage || "";
        var mapElement = root.querySelector("[data-directory-map-canvas]");
        var markers = getMarkerData(root);
        var MarkerClusterer = window.markerClusterer && window.markerClusterer.MarkerClusterer;
        var preserveInitialView = mapElement && mapElement.dataset.preserveView === "true";

        if (!mapElement || !markers.length) {
            setStatus(root, "No mappable member locations are available for these results.");
            return;
        }

        if (!window.google || !window.google.maps || !window.google.maps.importLibrary) {
            setStatus(root, "Google Maps is unavailable because no API key is configured.");
            return;
        }

        loadGoogleMaps()
            .then(function (maps) {
                return Promise.all([
                    maps.importLibrary("maps"),
                    maps.importLibrary("marker")
                ]);
            })
            .then(function (libraries) {
                var mapsLibrary = libraries[0];
                var markerLibrary = libraries[1];
                var googleMaps = window.google.maps;
                var centerLatitude = parseFloat(mapElement.dataset.centerLat);
                var centerLongitude = parseFloat(mapElement.dataset.centerLng);
                var initialZoom = parseInt(mapElement.dataset.zoom, 10);
                var AdvancedMarkerElement = markerLibrary.AdvancedMarkerElement;
                var bounds = new googleMaps.LatLngBounds();
                var infoWindow = new googleMaps.InfoWindow();
                var fallbackCenter = {
                    lat: markers[0].latitude,
                    lng: markers[0].longitude
                };
                var innerMap = new mapsLibrary.Map(mapElement, {
                    center: {
                        lat: !isNaN(centerLatitude) ? centerLatitude : fallbackCenter.lat,
                        lng: !isNaN(centerLongitude) ? centerLongitude : fallbackCenter.lng
                    },
                    fullscreenControl: false,
                    gestureHandling: "cooperative",
                    mapId: mapId,
                    mapTypeControl: false,
                    streetViewControl: false,
                    zoom: !isNaN(initialZoom) ? initialZoom : 6
                });
                var mapMarkers = [];

                markers.forEach(function (markerData) {
                    var position = {
                        lat: markerData.latitude,
                        lng: markerData.longitude
                    };
                    var markerContent = createMarkerImageContent(markerImageUrl, markerData.title);
                    var marker = new AdvancedMarkerElement({
                        content: markerContent || undefined,
                        map: !MarkerClusterer ? innerMap : undefined,
                        position: position,
                        title: markerData.title
                    });

                    bounds.extend(position);
                    mapMarkers.push(marker);

                    marker.addListener("click", function () {
                        infoWindow.setContent(createInfoWindowContent(markerData, markerImageUrl, markerAccentColor));
                        infoWindow.open({
                            anchor: marker,
                            map: innerMap
                        });
                    });
                });

                if (MarkerClusterer) {
                    new MarkerClusterer({
                        map: innerMap,
                        markers: mapMarkers,
                        renderer: createClusterRenderer(clusterStyles, AdvancedMarkerElement)
                    });
                }

                if (preserveInitialView) {
                    setStatus(root, "Showing " + markers.length + " member locations on the map.");
                    return;
                }

                if (markers.length === 1) {
                    innerMap.setCenter(bounds.getCenter());
                    innerMap.setZoom(10);
                } else {
                    innerMap.fitBounds(bounds, 48);
                }

                setStatus(root, "Showing " + markers.length + " member locations on the map.");
            })
            .catch(function (error) {
                setStatus(root, error.message);
            });
    }

    document.addEventListener("DOMContentLoaded", function () {
        Array.prototype.slice.call(document.querySelectorAll("[data-directory-map]"))
            .forEach(initMap);
    });
})();